import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Accordion, AccordionDetails, AccordionSummary, IconButton, Tooltip, Grid } from '@mui/material';
import { Delete, Save } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReportParameterComponent from './ReportParameterComponent';
import ReportParameterSummaryComponent from './ReportParameterSummaryComponent';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';

const ReportParameterListComponent = ({
  reportParameters,
  reportParameterTypes,
  reportContextParameters,
  onExpandedChanged,
  onPropertyChanged,
  onSave,
  onDelete,
  validation
}) => {
  const [t] = useTranslation();

  return reportParameters.map((item, index) => {
    const header = <ReportParameterSummaryComponent reportParameter={item} />;
    return (
      <Grid key={index} item xs={12}>
        <Accordion expanded={item.isExpanded} onChange={(_, isExpanded) => onExpandedChanged(isExpanded, index)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            {(item.isExpanded || (!item.isExpanded && !header)) && (
              <>
                <Grid item xs={12} md={9}>
                  <Typography color='error'>{validation |> getErrors}</Typography>
                </Grid>
                <Grid container spacing={1} justifyContent='flex-end' onClick={event => event.stopPropagation()}>
                  <Grid item>
                    <Tooltip title={t('Reports.Save')}>
                      <div>
                        <IconButton
                          color='primary'
                          onClick={onSave(index)}
                          disabled={!item.changed || !(validation[index] |> isValid) || (validation |> getErrors) !== ''}
                        >
                          <Save />
                        </IconButton>
                      </div>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title={t('Tooltips.Delete')}>
                      <IconButton color='primary' onClick={onDelete(item, index)}>
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </>
            )}
            {!item.isExpanded && header}
          </AccordionSummary>
          <AccordionDetails>
            <ReportParameterComponent
              reportParameter={item}
              reportParameterTypes={reportParameterTypes}
              reportContextParameters={reportContextParameters}
              onPropertyChanged={onPropertyChanged}
              index={index}
              validation={validation}
            />
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  });
};

ReportParameterListComponent.propTypes = {
  reportParameters: PropTypes.array.isRequired,
  reportParameterTypes: PropTypes.array,
  reportContextParameters: PropTypes.array,
  onExpandedChanged: PropTypes.func.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default ReportParameterListComponent;
